import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "LegendSettingsstyles__Container",
  componentId: "keen-widget-settings__l2cwad-0"
})(["&&&{display:flex;flex-direction:column;}"]);
export var PositionContainer = styled.div.withConfig({
  displayName: "LegendSettingsstyles__PositionContainer",
  componentId: "keen-widget-settings__l2cwad-1"
})(["&&&{min-width:250px;}"]);
export var AlignmentContainer = styled.div.withConfig({
  displayName: "LegendSettingsstyles__AlignmentContainer",
  componentId: "keen-widget-settings__l2cwad-2"
})(["&&&{min-width:170px;}"]);